const initalState = {
  login: {
    loginResult: '',
    loginStatus: false,
    redirect: false,
    prevSessionExists: false,
    ssoEnable: false,
    kerberosEnable: false,
    msg: '',
    tokenExpired: false,
  },
  auth: {
    validToken: false,
    requestProcessed: false,
    isExternalUser: false,
  }
};

export default initalState;